import axios from './axios'

export const getSubProjects = ({ params } = {}) => axios.get('sub_projects', { params })
export const getSubProjectsSummary = ({ params } = {}) => axios.get('sub_projects/summary', { params })
